import React from "react"
import Modal from "@material-ui/core/Modal"
import DialogContent from "@material-ui/core/DialogContent"
import InstantWinWheel from "./InstantWinWheel"
import './InstantWinModal.scss'


/**

    wheelConfig={
        title
        bodyCopy
        footerCopy
        prizeId - sent to InstantWinWheel
        shouldSpin - sent to InstantWinWheel
    }


*/
const InstantWinModal = ({ wheelConfig={}, data, isModalOpen, handleCloseModal=()=>{}, button, handleAfterSpin=()=>{} }) => {

  const style = {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    minHeight: "100vh",
    backdropFilter: "blur(2px)",
  }
  
  // using visibility: hidden helps minimize layout shift
  let forfeitStyle = {}
  if (wheelConfig.hideForfeit) {
    forfeitStyle = {visibility: "hidden"}
  }

  return (
    <>
      <Modal open={isModalOpen} onClose={handleCloseModal} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
        <DialogContent style={style}>
          <div className="modal-wrap instant-win-modal">
            <div className="modal-content">
              <button className={`modal-close`} onClick={handleCloseModal} aria-label="Next"></button>
              <h2 className="title">{wheelConfig.title}</h2>
              <h3 className="subtitle">{wheelConfig.bodyCopy}</h3>
              <InstantWinWheel
                data={data}
                button={button}
                wheelConfig={wheelConfig}
                handleAfterSpin={handleAfterSpin}
              />
              <div className="tandc" dangerouslySetInnerHTML={{ __html: wheelConfig.footerCopy }} />
              <div className="forfeit-container" style={forfeitStyle}>
                <span onClick={handleCloseModal} className="forfeit">
                    I'd like to forfeit
                </span>
              </div>
            </div>
          </div>
        </DialogContent>
      </Modal>
      
    </>
  )
}

export default InstantWinModal
